import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThirdPartyDestinationService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ThirdPartyDestinationCreateDto,
  ThirdPartyDestinationDto,
  ThirdPartyDestinationExcelDownloadDto,
  ThirdPartyDestinationUpdateDto,
} from '../proxy/planning/dtos/third-party-destination';
import { THIRDPARTYDESTINATION_CONFIG, THIRDPARTYDESTINATION_FIELDS } from './third-party-destination.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';

@Component({
  selector: 'app-third-party-destination',
  imports: [
    CommonModule,
    CrudPage,
    GenericForm,
    ZnHierarchicalViewComponent
  ],
  providers: [ListService, ThirdPartyDestinationService, ConfirmationService],
  templateUrl: './third-party-destination.html',
  styleUrl: './third-party-destination.scss',
})
export class ThirdPartyDestination extends BaseHierarchicalCrudComponent<
  ThirdPartyDestinationDto,
  ThirdPartyDestinationCreateDto,
  ThirdPartyDestinationUpdateDto,
  ThirdPartyDestinationExcelDownloadDto
> {
  service = inject(ThirdPartyDestinationService);
  config = THIRDPARTYDESTINATION_CONFIG;
  fields = THIRDPARTYDESTINATION_FIELDS;

  protected prepareUpdateDto(data: any, selected: ThirdPartyDestinationDto): ThirdPartyDestinationUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ThirdPartyDestination';
  }
}
